module.exports = __webpack_public_path__ + "static/media/target.16881175.png";